import axios from "axios"

async function buscarDadosEmpresas(params) {
    const batchGet = await _buscarDadosBatch(process.env.REACT_APP_ID_PLANILHA, ['EmpresasBEA', 'ProdutosBEA', 'VídeosBEA', 'Contatos', 'PontosDeVendaBEA', 'Imagens', 'Notícias'])

    const empresas = batchGet['EmpresasBEA']
    const produtos = batchGet['ProdutosBEA']
    const videos = batchGet['VídeosBEA']
    const contatos = batchGet['Contatos']
    const pontosDeVenda = batchGet['PontosDeVendaBEA']
    const imagens = batchGet['Imagens']
    const noticias = batchGet['Notícias']

    // Produtos

    for (let i = 0; i < produtos.length; i++) {
        for (let j = 0; j < empresas.length; j++) {
            if (empresas[j]['Empresa'] === produtos[i]['Empresa']) {

                // Se a chave de produtos ainda não existir, criar ela como um array vazio
                if (!empresas[j]['Produtos']) {
                    empresas[j]['Produtos'] = []
                }

                empresas[j]['Produtos'].push(produtos[i])
                break
            }
        }

    }

    // Vídeos
    for (let i = 0; i < videos.length; i++) {
        for (let j = 0; j < empresas.length; j++) {
            if (empresas[j]['Empresa'] === videos[i]['Empresa']) {

                // Se a chave dos vídeos ainda não existir, criar ela como um array vazio
                if (!empresas[j]['Vídeos']) {
                    empresas[j]['Vídeos'] = []
                }

                empresas[j]['Vídeos'].push(videos[i])
                break
            }
        }
    }

    // Contatos
    for (let i = 0; i < contatos.length; i++) {
        for (let j = 0; j < empresas.length; j++) {
            if (empresas[j]['Empresa'] === contatos[i]['Empresa']) {

                // Se a chave dos contatos ainda não existir, criar ela como um array vazio
                if (!empresas[j]['Contatos']) {
                    empresas[j]['Contatos'] = []
                }

                empresas[j]['Contatos'].push(contatos[i])
                break
            }
        }
    }

    // Pontos de venda
    for (let i = 0; i < pontosDeVenda.length; i++) {
        const splitEmpresas = pontosDeVenda[i]['Empresas no ponto de venda'].split(', ')

        for (let j = 0; j < empresas.length; j++) {
            if (splitEmpresas.includes(empresas[j]['Empresa'])) {

                // Se a chave de pontos de venda ainda não existir, criar ela como um array vazio
                if (!empresas[j]['Pontos de venda']) {
                    empresas[j]['Pontos de venda'] = []
                }

                empresas[j]['Pontos de venda'].push(pontosDeVenda[i])
                break
            }
        }

    }

    // Imagens
    for (let i = 0; i < imagens.length; i++) {
        for (let j = 0; j < empresas.length; j++) {
            if (empresas[j]['Empresa'] === imagens[i]['Empresa'] && imagens[i]['BEA']?.toUpperCase() === 'X') {

                // Se a chave das imagens ainda não existir, criar ela como um array vazio
                if (!empresas[j]['Imagens']) {
                    empresas[j]['Imagens'] = []
                }

                empresas[j]['Imagens'].push(imagens[i])
                break
            }
        }
    }

    // Notícias
    for (let i = 0; i < noticias.length; i++) {
        for (let j = 0; j < empresas.length; j++) {
            if (empresas[j]['Empresa'] === noticias[i]['Empresa'] && noticias[i]['BEA']?.toUpperCase() === 'X') {

                // Se a chave das notícias ainda não existir, criar ela como um array vazio
                if (!empresas[j]['Notícias']) {
                    empresas[j]['Notícias'] = []
                }

                empresas[j]['Notícias'].push(noticias[i])
                break
            }
        }
    }

    return empresas
}

async function buscarDadosProdutos(params) {
    const dadosProdutos = await _buscarDados(process.env.REACT_APP_ID_PLANILHA, 'ProdutosBEA')
    let produtosPorEmpresa = {}
    let produtosPorEspecie = {
        'Avicultura': [],
        'Bovinos - Centrais': [],
        'Bovinos de Corte': [],
        'Bovinos de Leite': [],
        'Pescados': [],
        'Suínos': [],
    }

    let produtosPorTema = {}
    let produtosPorCategoria = {}

    dadosProdutos.map((produto) => {
        // Incluindo na lista de produtos por empresa
        if (!produtosPorEmpresa[produto['Empresa']]) {
            produtosPorEmpresa[produto['Empresa']] = []
        }

        produtosPorEmpresa[produto['Empresa']].push(produto)

        // Incluindo na lista de produtos por espécie
        if (produto['Avicultura']?.toUpperCase() === 'X') {
            produtosPorEspecie['Avicultura'].push(produto)
        }

        if (produto['Bovinos - Centrais']?.toUpperCase() === 'X') {
            produtosPorEspecie['Bovinos - Centrais'].push(produto)
        }

        if (produto['Bovinos de Corte']?.toUpperCase() === 'X') {
            produtosPorEspecie['Bovinos de Corte'].push(produto)
        }

        if (produto['Bovinos de Leite']?.toUpperCase() === 'X') {
            produtosPorEspecie['Bovinos de Leite'].push(produto)
        }

        if (produto['Pescados']?.toUpperCase() === 'X') {
            produtosPorEspecie['Pescados'].push(produto)
        }

        if (produto['Suínos']?.toUpperCase() === 'X') {
            produtosPorEspecie['Suínos'].push(produto)
        }

        // Incluindo na lista de produtos Por tema
        if (!produtosPorTema[produto['Tema']]) {
            produtosPorTema[produto['Tema']] = []
        }

        produtosPorTema[produto['Tema']].push(produto)


        // Incluindo na lista de produtos Por categoria
        // A tag <em> é utilizada na planilha para dar o efeito itálico. Vamos remover ela aqui para não ficar assim no combo de opção dos filtros.
        const categoriaProdutoTratada = produto['Categoria'].replaceAll('</em>', '').replaceAll('<em>', '')

        if (!produtosPorCategoria[categoriaProdutoTratada]) {
            produtosPorCategoria[categoriaProdutoTratada] = []
        }

        produtosPorCategoria[categoriaProdutoTratada].push(produto)
    })

    // Ordenando temas por ordem alfabética

    produtosPorTema = Object.fromEntries(Object.entries(produtosPorTema).sort())

    // Ordenando categorias por ordem alfabética

    produtosPorCategoria = Object.fromEntries(Object.entries(produtosPorCategoria).sort())

    // Deletando espécies sem produto

    for (let i = 0; i < Object.keys(produtosPorEspecie).length; i++) {
        if (produtosPorEspecie[Object.keys(produtosPorEspecie)[i]].length === 0) {
            // Deletando item e voltando um valor no i do forloop para evitar pular alguma key
            delete produtosPorEspecie[Object.keys(produtosPorEspecie)[i]]
            i--
        }
    }

    return { produtosPorEmpresa, produtosPorEspecie, produtosPorTema, produtosPorCategoria, temas: Object.keys(produtosPorTema), categorias: Object.keys(produtosPorCategoria), especies: Object.keys(produtosPorEspecie) }
}

async function buscarDadosProdutosSemSeparacaoPorEmpresa(params) {
    const batchGet = await _buscarDadosBatch(process.env.REACT_APP_ID_PLANILHA, ['ProdutosBEA', 'VídeosProdutos', 'Imagens', 'Notícias'])

    const dadosProdutos = batchGet['ProdutosBEA']
    const videos = batchGet['VídeosProdutos']
    const imagens = batchGet['Imagens']
    const noticias = batchGet['Notícias']

    // Vídeos
    for (let i = 0; i < videos.length; i++) {
        for (let j = 0; j < dadosProdutos.length; j++) {
            if (dadosProdutos[j]['Nome do produto/serviço'] === videos[i]['Produto/Serviço']) {

                // Se a chave dos vídeos ainda não existir, criar ela como um array vazio
                if (!dadosProdutos[j]['Vídeos']) {
                    dadosProdutos[j]['Vídeos'] = []
                }

                dadosProdutos[j]['Vídeos'].push(videos[i])

                break
            }
        }
    }

    // Imagens
    for (let i = 0; i < imagens.length; i++) {
        for (let j = 0; j < dadosProdutos.length; j++) {
            if (dadosProdutos[j]['Nome do produto/serviço'] === imagens[i]['Produto'] && imagens[i]['BEA']?.toUpperCase() === 'X') {

                // Se a chave das imagens ainda não existir, criar ela como um array vazio
                if (!dadosProdutos[j]['Imagens']) {
                    dadosProdutos[j]['Imagens'] = []
                }

                dadosProdutos[j]['Imagens'].push(imagens[i])

                break
            }
        }
    }

    // Notícias
    for (let i = 0; i < noticias.length; i++) {
        for (let j = 0; j < dadosProdutos.length; j++) {
            if (dadosProdutos[j]['Nome do produto/serviço'] === noticias[i]['Produto'] && noticias[i]['BEA']?.toUpperCase() === 'X') {

                // Se a chave das notícias ainda não existir, criar ela como um array vazio
                if (!dadosProdutos[j]['Notícias']) {
                    dadosProdutos[j]['Notícias'] = []
                }

                dadosProdutos[j]['Notícias'].push(noticias[i])

                break
            }
        }
    }


    return dadosProdutos
}

async function _buscarDados(idPlanilha, nomeAba) {
    const res = await axios.get(`https://sheets.googleapis.com/v4/spreadsheets/${idPlanilha}/values/${nomeAba}?key=${process.env.REACT_APP_SHEETS_KEY}`)

    const colunas = res.data.values[0]
    const linhas = res.data.values.slice(1, res.data.values.length)

    const objetos = []

    for (let i = 0; i < linhas.length; i++) {
        const objeto = {}

        for (let j = 0; j < linhas[i].length; j++) {
            objeto[colunas[j]] = linhas[i][j]
        }

        objetos.push(objeto)
    }

    return objetos
}

async function _buscarDadosBatch(idPlanilha, nomesAbas) {
    let rangesString = ''

    for (let i = 0; i < nomesAbas.length; i++) {
        rangesString += `&ranges=${nomesAbas[i]}`
    }

    const batchUrl = `https://sheets.googleapis.com/v4/spreadsheets/${idPlanilha}/values:batchGet?key=${process.env.REACT_APP_SHEETS_KEY}${rangesString}`

    const res = await axios.get(batchUrl)

    const ranges = res.data.valueRanges

    const resultado = {}

    for (let i = 0; i < nomesAbas.length; i++) {
        const colunas = ranges[i].values[0]
        const linhas = ranges[i].values.slice(1, ranges[i].values.length)

        const objetos = []

        for (let i = 0; i < linhas.length; i++) {
            const objeto = {}

            for (let j = 0; j < linhas[i].length; j++) {
                objeto[colunas[j]] = linhas[i][j]
            }

            objetos.push(objeto)
        }

        resultado[nomesAbas[i]] = objetos
    }

    return resultado
}

const exports = { buscarDadosEmpresas, buscarDadosProdutos, buscarDadosProdutosSemSeparacaoPorEmpresa }

export default exports